export const conversationChannelColorClassMap = {
  instagram: 'text-[#E4405F]',
  facebook: 'text-[#1877F2]',
  whatsapp: 'text-[#25D366]',
  website: 'text-[#0F766E]',
  api: 'text-[#2563EB]',
};

export const getConversationChannelColorClass = channelType => {
  return conversationChannelColorClassMap[channelType] || 'text-n-slate-11';
};
